const ajaxPagination = (totalPages) => {
  const productsList = document.getElementById("archive-loop-section");
  const prev = document.querySelector(".gallery-arrow.prev");
  const next = document.querySelector(".gallery-arrow.next");
  const numbers = document.querySelectorAll(".pagination-btn");
  let currentPage = 1;

  // init Pagination
  initPagination(productsList, next, totalPages);

  if (prev && next) {
    // Btn Previous Page Behaviour
    prev.addEventListener("click", () => {
      currentPage = prevBtnBehaviour(productsList, currentPage, prev, next);
    });

    // Btn Next Page Behaviour
    next.addEventListener("click", () => {
      currentPage = nextBtnBehavior(productsList, currentPage, prev, next);
    });
  }

  if (numbers.length > 0) {
    numbers.forEach((number) => {
        number.addEventListener("click", () => {
          currentPage = number.value;
          numbers.forEach((num) => {
            num.classList.remove("active");
          });
          changePage(productsList, currentPage);
          number.classList.add("active");
        });
      });
  }
};

export default ajaxPagination;

/**
 * Init Pagination
 *
 * @param {*} productsList
 * @param {*} next
 * @param {*} totalPages
 */

const initPagination = (productsList, next, totalPages) => {
  productsList.dataset.total = totalPages;
  if (totalPages != 1) {
    next.style.display = "block";
  } else {
    document.querySelectorAll(".gallery-arrow").forEach((btn) => {
      btn.style.display = "none";
    });
  }
  document.querySelectorAll(".archive-post").forEach((post) => {
    if (post.dataset.page != 1) post.style.display = "none";
  });
};

/**
 * Btn Previous Page Behaviour
 *
 * @param {*} productsList
 * @param {*} currentPage
 * @param {*} prev
 * @param {*} next
 */

const prevBtnBehaviour = (productsList, currentPage, prev, next) => {
  let total = productsList.dataset.total;
  if (currentPage > 1) {
    currentPage--;
    if (currentPage != total) next.disabled = false;
    changePage(productsList, currentPage);
    if (currentPage == 1) prev.disabled = true;
  }
  return currentPage;
};

/**
 * Btn Next Page Behaviour
 *
 * @param {*} productsList
 * @param {*} currentPage
 * @param {*} prev
 * @param {*} next
 */

const nextBtnBehavior = (productsList, currentPage, prev, next) => {
  let total = productsList.dataset.total;
  if (currentPage < total) {
    currentPage++;
    if (currentPage != 1) prev.disabled = false;
    changePage(productsList, currentPage);
    if (currentPage == total) next.disabled = true;
  }
  return currentPage;
};

/**
 * Change Page
 *
 * @param {*} productsList
 * @param {*} currentPage
 */

const changePage = (productsList, currentPage) => {
  document.querySelectorAll(".archive-post").forEach((post) => {
    if (post.dataset.page != currentPage) {
      post.style.display = "none";
    } else {
      post.style.display = "block";
    }
  });

  if (productsList) {
    window.scrollTo({
      top: productsList.getBoundingClientRect().top + window.scrollY - 208,
      behavior: "smooth",
    });
  }
};
